import i18n from '@/i18n';

export const degrees = {
	basic: {
		value: 0,
		text: i18n.t('degrees.basic'),
	},
	highSchool: {
		value: 1,
		text: i18n.t('degrees.highSchool'),
	},
	university: {
		value: 2,
		text: i18n.t('degrees.university'),
	},
	master: {
		value: 3,
		text: i18n.t('degrees.master'),
	},
	phd: {
		value: 4,
		text: i18n.t('degrees.phd'),
	},
};

export const sex = {
	male: 0,
	female: 1,
};

export const militaryState = {
	undefined: {
		value: 0,
		text: i18n.t('militaryState.undefined'),
	},
	performed: {
		value: 1,
		text: i18n.t('militaryState.performed'),
	},
	delayed: {
		value: 2,
		text: i18n.t('militaryState.delayed'),
	},
	exempt: {
		value: 3,
		text: i18n.t('militaryState.exempt'),
	},
};

export const socialState = {
	single: 0,
	married: 1,
	divorced: 2,
};

export const contactsType = {
	mobile: {
		text: i18n.t('contacts.mobile'),
		value: 0,
	},
	phone: {
		text: i18n.t('contacts.phone'),
		value: 1,
	},
	email: {
		text: i18n.t('contacts.email'),
		value: 2,
	},
	facebook: {
		text: i18n.t('contacts.facebook'),
		value: 3,
	},
	twitter: {
		text: i18n.t('contacts.twitter'),
		value: 4,
	},
	whatsapp: {
		text: i18n.t('contacts.whatsapp'),
		value: 5,
	},
	telegram: {
		text: i18n.t('contacts.telegram'),
		value: 6,
	},
	linkedIn: {
		text: i18n.t('contacts.linkedIn'),
		value: 7,
	},
	website: {
		text: i18n.t('contacts.website'),
		value: 8,
	},
	address: {
		text: i18n.t('contacts.address'),
		value: 9,
	},
	instagram: {
		text: i18n.t('contacts.instagram'),
		value: 10,
	},
};

export const attendanceType = {
	all: {
		value: 0,
		text: i18n.t('attendance-types.all'),
	},
	committed: {
		value: 1,
		text: i18n.t('attendance-types.committed'),
	},
	late: {
		value: 2,
		text: i18n.t('attendance-types.late'),
	},
	earlyLeave: {
		value: 3,
		text: i18n.t('attendance-types.earlyLeave'),
	},
	// earlyDeparture
	absence: {
		value: 4,
		text: i18n.t('attendance-types.absence'),
	},
};

export const vacationType = {
	vacation: {
		text: i18n.t('vacationType.vacation'),
		value: 0,
	},
	permission: {
		text: i18n.t('vacationType.permission'),
		value: 1,
	},
};

export const vacationFrequency = {
	undefined: {
		text: 'غير معروف',
		value: 0,
	},
	monthly: {
		text: 'شهري',
		value: 1,
	},
	annual: {
		text: 'سنوي',
		value: 2,
	},
	once: {
		text: 'مرا واحدة',
		value: 3,
	},
	SemiAnnually: {
		text: 'نصف سنوي',
		value: 4,
	},
};

export const employeesTypes = {
	all: {
		value: null,
		text: 'الكل',
	},
	// UnDefined
	applicants: {
		value: 3,
		text: 'المتقدمين',
	},
	// Breakup
	former: {
		value: 1,
		text: 'السابقين',
	},
	// TemporaryAppointment
	temporaries: {
		value: 2,
		text: 'المؤقتين',
	},
	// Stabilizing
	currently: {
		value: 0,
		text: 'المثبتين',
	},
};

export const jobRecords = {
	MovedToSection: {
		value: 0,
		text: i18n.t('jobRecord.MovedToSection'),
	},
	EndAssignmentSection: {
		value: 1,
		text: i18n.t('jobRecord.EndAssignmentSection'),
	},
	SetSection: {
		value: 2,
		text: i18n.t('jobRecord.SetSection'),
	},
	Stabilizing: {
		value: 3,
		text: i18n.t('jobRecord.Stabilizing'),
	},
	TemporaryAppointment: {
		value: 4,
		text: i18n.t('jobRecord.TemporaryAppointment'),
	},
	ChangingJobTitle: {
		value: 5,
		text: i18n.t('jobRecord.ChangingJobTitle'),
	},
	Breakup: {
		value: 6,
		text: i18n.t('jobRecord.Breakup'),
	},
	ChangePermanentSystem: {
		value: 7,
		text: i18n.t('jobRecord.ChangePermanentSystem'),
	},
	ChangeSalary: {
		value: 8,
		text: i18n.t('jobRecord.ChangeSalary'),
	},
	UnDefined: {
		value: 9,
		text: i18n.t('jobRecord.UnDefined'),
	},
};

export const detailsType = {
	text: 0,
	date: 1,
	options: 2,
};

export const timeTypeEnum = {
	daily: 0,
	hourly: 1,
};

export const fingerPrintStatus = {
	modified: 1,
	dedicated: 2
};

export const penaltyRewardType = {
	rewards: 0,
	penalty: 1,
};

export const penaltyRewardValueType = {
	rate: 0,
	static: 1,
	days: 2,
};

export const penaltyRewardValueTypes = [
	{ id: 0, name: i18n.t('penalty-reward-value-types.rate') },
	{ id: 1, name: i18n.t('penalty-reward-value-types.static') },
	{ id: 2, name: i18n.t('penalty-reward-value-types.days') },
];

export const salaryType = {
	daily: 0,
	weekly: 2,
	monthly: 3,
	annual: 1,
};

export const applyingTypes = [
	{ id: 0, name: i18n.t('applying-types.daily')},
	{ id: 2, name: i18n.t('applying-types.weekly')},
	{ id: 3, name: i18n.t('applying-types.monthly')},
	{ id: 1, name: i18n.t('applying-types.annual')},
];

export const recompenseCalculateMethod = {
	all: 0,
	actualWork: 1
};

export const recompenseCalculateMethods = [
	{ id: 0, name: i18n.t('recompense-calculate-methods.all') },
	{ id: 1, name: i18n.t('recompense-calculate-methods.actual-work') }
];

export const evaluationsTypes = [
	{ id: 1, name: i18n.t('rating.excellent') },
	{ id: 2, name: i18n.t('rating.good') },
	{ id: 3, name: i18n.t('rating.fair') },
	{ id: 4, name: i18n.t('rating.poor') },
	{ id: 5, name: i18n.t('rating.bad') },
];

export const detailTypes = [
	{
		id: 0,
		name: 'نص'
	},
	{
		id: 1,
		name: 'تاريخ'
	},
	{
		id: 2,
		name: 'خيارات'
	},
	{
		id: 3,
		name: 'سؤال'
	},
	{
		id: 4,
		name: 'غبر معروف'
	}
]
